import {
  Component, Directive,
  Injector,
  Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";

const DEFAULT_CLS = 'app-footer clearfix';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-footer',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: '[wmFooter]',
  providers: [
    provideAsWidgetRef(FooterComponent)
  ],
  exportAs: 'wmFooter',
  standalone: true
})
export class FooterComponent extends StylableComponent {
  static initializeProps = register('wm-footer');

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

}

